import { RequiredSterickStyled } from "./requiredsterick.styles";

const RequiredSterick = (): JSX.Element => {
  return <RequiredSterickStyled>*</RequiredSterickStyled>;
};

export default RequiredSterick;
